import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useNavigate } from "react-router-dom";

function MetricCard({
  title,
  content,
  color,
  textColor = "#000000",
  titleTop = true,
  navigateUrl = null,
}) {
  const navigate = useNavigate();

  const onClickNavigate = () => {
    if (navigateUrl == null) {
      return;
    }
    navigate(navigateUrl);
  };

  return (
    <Box
      component="div"
      sx={{ display: "inline-block", mx: "2px", width: "100%" }}
      className="metricCard"
    >
      <Card
        variant="outlined"
        sx={{
          backgroundColor: color + "!important",
          cursor: navigateUrl != null ? "pointer" : "normal",
        }}
        onClick={onClickNavigate}
      >
        <CardContent>
          {titleTop === true && (
            <Typography
              gutterBottom
              className="metricCard"
              sx={{ fontSize: "1.2em", color: textColor, textAlign: "center", mb:0 }}
            >
              {title}
            </Typography>
          )}
          <Typography
            component="div"
            className="metricCard"
            sx={{ fontSize: "2.0em", color: textColor, textAlign: "center", mb:0 }}
          >
            {content}
          </Typography>
          {titleTop === false && (
            <Typography
              gutterBottom
              className="metricCard"
              sx={{ fontSize: "1.2em", color: textColor, textAlign: "center", mb:0 }}
            >
              {title}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
export default MetricCard;
